module.exports = __webpack_public_path__ + "img/aba-web-top-logo.222aba57.png";